export const PLANS = 'PLANS'
export const PAGINATE_PLANS = 'PAGINATE_PLANS'
export const ERROR_STATE = 'ERROR_STATE'
